import styled from 'styled-components';

import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface StyledThumbnailsToggleProps {
	isOpened: boolean;
}

const StyledThumbnailsToggle = styled('button')`
	flex: ${(props: StyledThumbnailsToggleProps) => props.isOpened ? '0 0 40px' : '0 0 30px'};
	display: flex;
	align-items: center;
	justify-content: center;
	border: 0;
	outline: 0;
	background-color: ${NewStyleColor.Grey900};

	${(props: StyledThumbnailsToggleProps) => props.isOpened
		? ''
		: `border-left: 2px solid ${hexToRgba(StyleColor.White, 10)}; margin-right: 27px; transform: rotate(180deg);`
	}

	svg {
		width: 16px;
		height: 16px;
		fill: ${hexToRgba(StyleColor.White, 10)};
	}
`;

export {
	StyledThumbnailsToggle,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ThumbnailsToggle/styles.ts